import { requestSearch } from "../api/searchRequest";

const searchApi = requestSearch();

const getMetaResults = async (uuid, word, anchors, customParams) =>
  await searchApi.get(
    `/${uuid}/search/${encodeURIComponent(word)}?page=1&${anchors}${
      customParams || ""
    }`
  );

const getSearchResults = async (
  uuid,
  word,
  page,
  query,
  anchors,
  cacheKey,
  sortKey,
  customParams
) =>
  await searchApi.post(
    `/${uuid}/search/${encodeURIComponent(word)}?page=${page}&${anchors || ""}${
      cacheKey || ""
    }${sortKey || ""}${customParams || ""}`,
    query
  );

export default { getSearchResults, getMetaResults };
